module.exports = __webpack_public_path__ + "static/media/ios-app-store-logo.1b94a031.png";